<dx-popup *ngIf="__bConfirmationVisible"
          [wrapperAttr]="{ class: __sCSSClass }"
id="ppConfirmation" [width]="650" [(height)]="__iPopupHeight" [showTitle]="true" [dragEnabled]="false"
    title="{{__sMessageTitle}}" [hideOnOutsideClick]="false" [(visible)]="__bConfirmationVisible">
    <div *dxTemplate="let data of 'content'">

        <div class="row message-border">
            <div class="col-lg-12 col-md-12 col-xs-12 message-box">
                <div [innerHTML]="__sMessage"></div>
            </div>
        </div>

        <div class="row" style="margin: 0px; ">
            <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
                <div class="col-lg-12 col-md-12 col-xs-12 padding0px" style="float: right;">
                    <dx-button id="btnContinue" (onClick)="onConfirmationClick(true)" [text]="__sOkBtnText" [disabled]="__bContinueDisbled"></dx-button>
                    <dx-button id="btnContinue" *ngIf="__sSecBtnText" (onClick)="onConfirmationClick(__sSecBtnText)" [text]="__sSecBtnText"></dx-button>
                    <dx-button id="btnCancel" [(visible)]="__bIsCancelVisible" class="btn-secondary" (onClick)="onConfirmationClick(false)" [text]="__sCancelBtnText"></dx-button>
                </div>
            </div>
        </div>

    </div>
</dx-popup>
